import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      icon: 'CheckCircle',
      title: 'API Certified',
      description: 'Official platform APIs'
    },
    {
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'Data privacy protected'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        {trustBadges?.map((badge, index) => (
          <div key={index} className="flex flex-col items-center text-center space-y-2">
            <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
              <Icon name={badge?.icon} size={20} color="var(--color-success)" />
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground">{badge?.title}</p>
              <p className="text-xs text-muted-foreground">{badge?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;